import { axiosAppsAuth } from "@/utils/axios";

export default class PriceList {
	constructor(price_list) {
		this.price_list = price_list ? price_list : null;
	}

	async find(id) {
		try {
			let response = await axiosAppsAuth.get(`/pricelist/${id}`);

			return response.data.data;
		} catch (error) {
			throw error;
		} finally {
		}
	}

	async update() {
		try {
			let response = await axiosAppsAuth.put(
				`/pricelist/${this.price_list.id}`,
				this.price_list
			);

			return response.data.data;
		} catch (error) {
			throw error;
		} finally {
		}
	}
}
